// tslint:disable:max-line-length

import React from 'react';

export const ChartMap = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.3,0H0v16h6.3l5.6-7.5 M11.9,8.5 M4.7,13c0,0-2.8-3.6-2.8-5.7c0-1.5,1.2-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8 C7.4,9.6,4.7,13,4.7,13z M5.7,7.1c0,0.6-0.4,1.1-1.1,1.1S3.6,7.7,3.6,7.1S4,6,4.7,6S5.7,6.5,5.7,7.1z M6.3,0H16v3l-3.2,4.2L6.3,0z M16,10.8l-2.2-2.4L16,5.5V10.8z M16,13.1V16H8.2l4.8-6.4L16,13.1z" />
    </svg>
  );
};
